module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "",
      "center": true,
      "visible": _vm.particularsVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.particularsVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "particulars-view"
  }, [_c('div', {
    staticClass: "descriptions-title-view"
  }, [_vm._v("\n      视频评论信息详情\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "descriptions-view"
  }, [_c('div', {
    staticClass: "descriptions-item"
  }, [_c('div', {
    staticClass: "descriptions-item-view"
  }, [_c('div', {
    staticClass: "descriptions-title"
  }, [_c('el-tag', {
    attrs: {
      "size": "medium"
    }
  }, [_vm._v("视频ID:")])], 1), _vm._v(" "), _c('div', {
    staticClass: "descriptions-value"
  }, [_vm._v("\n            " + _vm._s(_vm.particularsData.videoDataId) + "\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "descriptions-item"
  }, [_c('div', {
    staticClass: "descriptions-item-view"
  }, [_c('div', {
    staticClass: "descriptions-title"
  }, [_c('el-tag', {
    attrs: {
      "size": "medium"
    }
  }, [_vm._v("平台用户ID:")])], 1), _vm._v(" "), _c('div', {
    staticClass: "descriptions-value"
  }, [_vm._v("\n            " + _vm._s(_vm.particularsData.platformUserId) + "\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "descriptions-item"
  }, [_c('div', {
    staticClass: "descriptions-item-view"
  }, [_c('div', {
    staticClass: "descriptions-title"
  }, [_c('el-tag', {
    attrs: {
      "size": "medium"
    }
  }, [_vm._v("评论内容:")])], 1), _vm._v(" "), _c('div', {
    staticClass: "descriptions-value"
  }, [_vm._v("\n            " + _vm._s(_vm.particularsData.commentText) + "\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "descriptions-item"
  }, [_c('div', {
    staticClass: "descriptions-item-view"
  }, [_c('div', {
    staticClass: "descriptions-title"
  }, [_c('el-tag', {
    attrs: {
      "size": "medium"
    }
  }, [_vm._v("星级:")])], 1), _vm._v(" "), _c('div', {
    staticClass: "descriptions-value"
  }, [_vm._v("\n            " + _vm._s(_vm.particularsData.starNum) + "\n          ")])])])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "append-to-body": "",
      "visible": _vm.previewVisible,
      "title": "图片预览"
    },
    on: {
      "update:visible": function($event) {
        _vm.previewVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.previewImageUrl,
      "alt": ""
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v("关闭")])], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2f6720ac", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f6720ac"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/videoComment/ItemParticulars.vue
// module id = 1272
// module chunks = 1